import { HttpClient } from '@angular/common/http';
import { Base } from './base';

export class SystemConfig extends Base {
  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'system_config');
  }

  query(params?: any) {
    return this.api.query(params);
  }
}
